import { type FC } from "react";
import { EmptyStateImage } from "@onshopfront/components";
import FourZeroFourSVG from "./404.svg";

const FourZeroFour: FC = () => {
    return (
        <EmptyStateImage image={FourZeroFourSVG} />
    );
};

export default FourZeroFour;
